import { axiosInstance } from "../../../utils";

const actions = {
    CREATE_OR_UPDATE_CATEGORY_REQUESTED: 'CREATE_OR_UPDATE_CATEGORY_REQUESTED',
    CREATE_OR_UPDATE_CATEGORY_SUCCEEDED: 'CREATE_OR_UPDATE_CATEGORY_SUCCEEDED',
    CREATE_OR_UPDATE_CATEGORY_FAILED: 'CREATE_OR_UPDATE_CATEGORY_FAILED',

    CLEAR_ALERT_MESSAGE: 'CLEAR_ALERT_MESSAGE',

    clearAlertMessage: (params = undefined) => {
        return {
            type: actions.CLEAR_ALERT_MESSAGE,
            payload: params
        }
    },

    addOrUpdateCategory: (data = undefined) => {
        return {
            type: actions.CREATE_OR_UPDATE_CATEGORY_REQUESTED,
            payload: data
        }
    },

    createOrUpdateCategory: async (data = undefined) => {
        let url = `categories/create`;
        let bodyFormData = new FormData();

        if (data.name && data?.nameChanged) bodyFormData.set('name', data.name);
        if (data.name_ar && data?.nameArChanged) bodyFormData.set('name_ar', data.name_ar);
        if (data.parent_ids) bodyFormData.set('parent_ids', JSON.stringify(data.parent_ids));
        if (data.color) bodyFormData.set('color', data.color);
        if (data.icon) bodyFormData.append('icon', data.icon);
        if (data.thumbnail) bodyFormData.append('thumbnail', data.thumbnail);

        if (data._id) {
            url = `categories/` + data._id
            try {
                const category = await axiosInstance.put(url, bodyFormData);
                return category.data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const category = await axiosInstance.post(url, bodyFormData);
                return category.data;
            } catch (error) {
                throw error;
            }
        }
    },
};

export default actions;
